import loader from './modules/loaderObserver-functions';

loader.init();


//on page ready --> delete landing-loader x prevenire bugs in fase di delete x casistica loader fullpage asinc



/*
How To Use:


    show-hide fullpage loader: [

        NB: in casistica fullpage si puo omettere il domNode ( implicito e forzato a document.body ) sia in apply sia in destroy

        const showLoaderEvent = new CustomEvent( 'loader::apply' , { detail: { domNode: document.body , loaderType: 'fullpage' , loaderText: 'testo specifico diverso dal default' } } );
        document.dispatchEvent(showLoaderEvent);

        const destroyLoaderEvent = new CustomEvent( 'loader::destroy' , { detail: { domNode: document.body } } );
        document.dispatchEvent(destroyLoaderEvent);

        oppure (solo x fullpage)

        const destroyLoaderEvent = new CustomEvent( 'loader::destroy' , { detail: { loaderType: 'fullpage' } } );
        document.dispatchEvent(destroyLoaderEvent);
    ]

    show-hide dialog loader [
        NB: domNode deve avere position relativi/absolute/fixed -> si posiziona fixed nel domNode specificato
    }

    show-hide empty text loader [

        NB: in casistica empty text non si deve omettere ma settare come stringa vuota ''

        const showLoaderEvent = new CustomEvent( 'loader::apply' , { detail: { domNode: document.getElementById('app_scaduti_loader') , loaderType: 'small' , loaderText: ''  } } );
        document.dispatchEvent(showLoaderEvent);

        const hideLoaderEvent = new CustomEvent( 'loader::destroy' , { detail: { domNode: document.getElementById('app_scaduti_loader') } } );
        document.dispatchEvent(hideLoaderEvent);
    ]

*/


// WEBPACK FOOTER //
// ./cpanel/js/components/loader/loaderObserver.js